import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeletionDialogComponent } from 'src/app/layout/deletion-dialog/deletion-dialog.component';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';
import { SpinnerService } from 'src/app/layout/spinner.service';
import { BrokerSettingsDialogComponent } from './broker-settings-dialog/broker-settings-dialog.component';
import { Broker } from './broker-settings.model';
import { BrokerSettingsService } from './broker-settings.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatChip } from '@angular/material/chips';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-broker-settings',
    templateUrl: './broker-settings.component.html',
    styleUrls: ['./broker-settings.component.scss'],
    imports: [MatDivider, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatChip, NgClass, MatIconButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class BrokerSettingsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  parent: any;
  data: any;

  displayedColumns: string[] = ['id', 'brokerName', 'status', 'actions'];
  tabledata: Broker[] = [];
  dataSource = new MatTableDataSource();
  dialogConfig = new MatDialogConfig();

  searchForm: UntypedFormGroup;
  constructor(
    private snackbarService: SnackbarService,
    private brokerSettingsService: BrokerSettingsService,
    private dialog: MatDialog,
    private spinnerService: SpinnerService
  ) {}

  ngOnInit(): void {
    this.fetchData();

    this.searchForm = new UntypedFormGroup({
      filter: new UntypedFormControl(''),
    });
  }

  openAdd(): void {
    const dialogRef = this.dialog.open(BrokerSettingsDialogComponent, {
      width: '700px',
    });
    dialogRef.afterClosed().subscribe((data: Broker) => {
      if (data) {
        this.submit(data);
      }
    });
  }

  openEdit(data: any, rowIndex?: number): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = data;
    dialogConfig.width = '700px';

    const dialogRef = this.dialog.open(
      BrokerSettingsDialogComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((data: Broker) => {
      if (data) {
        this.submit(data);
      }else{
        this.fetchData();
      }
    });
  }

  submit(broker: Broker): void {
    this.spinnerService.startSpinner();
    // wenn id vorhanden: update
    if (broker.id) {
      this.brokerSettingsService.putBroker(broker).subscribe(
        (data: Broker) => {
          for (let i = 0; i < this.tabledata.length; i++) {
            if (this.tabledata[i].id == data.id) {
              this.tabledata[i] = data;
              this.spinnerService.stopSpinner();
              this.snackbarService.openSuccess();
            }
          }

          this.refreshTable(this.tabledata);
        },
        (error: any) => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openError(error.status);
        }
      );
    } else {
      // wenn keine id vorhanden: create
      this.brokerSettingsService.postBroker(broker).subscribe(
        (data: Broker) => {
          this.tabledata.push(data);
          this.refreshTable(this.tabledata);
          this.spinnerService.stopSpinner();
          this.snackbarService.openSuccess();
        },
        (error: any) => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openError(error.status);
        }
      );
    }
  }

  fetchData(): void {
    this.spinnerService.startSpinner();
    this.brokerSettingsService.fetchBrokers().subscribe(
      (data: Broker[]) => {
        this.tabledata = data;

        this.dataSource = new MatTableDataSource(this.tabledata);
        this.dataSource.paginator = this.paginator;
        this.spinnerService.stopSpinner();
      },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }

  refreshTable(tabledata: Broker[]): void {
    this.dataSource = new MatTableDataSource(tabledata);
    this.dataSource.paginator = this.paginator;
  }

  deleteColumn(broker: Broker, index: number): void {
    const dialogRef = this.dialog.open(
      DeletionDialogComponent,
      this.dialogConfig
    );

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.spinnerService.startSpinner();
        this.brokerSettingsService.deleteBroker(broker.id).subscribe(
          () => {
            this.fetchData();
            this.snackbarService.openSuccess();
          },
          (error: any) => {
            this.spinnerService.stopSpinner();
            this.snackbarService.openError(error.status);
          }
        );
      }
    });
  }

  // -- search --

  clearSearch(): void {
    this.searchForm.controls['filter'].setValue('');
    this.applyFilter();
  }

  applyFilter(): void {
    const filterValue = this.searchForm.value.filter;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
